import {
    Box,
    Button,
    ButtonGroup,
    Chip,
    Stack,
    styled,
    TextareaAutosize,
} from "@mui/material";
import { ChangeEvent, useContext } from "react";
import { DialogContext } from "../../../contexts/DialogContext";
import { SmsDescriptionHelper } from "../../../utils/SmsCountHelper";
import ListSmsTemplatesDialog from "../dialogs/ListSmsTemplatesDialog";

const StyledTextarea = styled(TextareaAutosize)(
    ({ theme }) => `
    width: 100%;
    border-radius: ${theme.shape.borderRadius}px;
    border: 1px solid ${theme.palette.divider};
    padding: 12px;
    resize: none;
    padding-bottom: 45px;
    outline: 0;
    font-family: ${theme.typography.fontFamily};
  `
);

export default function SmsCampaignTextArea(props: {
    template: string;
    onTextChange: (template: string) => void;
}) {
    const { openDialog } = useContext(DialogContext);

    const handleMessageChange = (
        elem: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const message = elem.target.value;
        props.onTextChange(message);
    };

    const handleTemplateSelection = (template: string) => {
        props.onTextChange(template);
    };

    const addConstructorNamePlaceHolder = () => {
        const target = document.getElementById("content-text-area");
        target.focus();
        document.execCommand("insertText", false /*no UI*/, "{*}");
    };

    const openSelectTemplate = () => {
        openDialog(
            <ListSmsTemplatesDialog onSelection={handleTemplateSelection} />
        );
    };

    // const charCount = props.template.length + 6;
    const charCount = props.template?.length ?? 0;
    const partCount = SmsDescriptionHelper.count(props.template || "");
    const isPersian = SmsDescriptionHelper.isPersian(props.template || "");

    return (
        <Box>
            <Box sx={{ position: "relative", display: "flex" }}>
                <StyledTextarea
                    id="content-text-area"
                    className={"padding-bottom"}
                    minRows={5}
                    onChange={handleMessageChange}
                    value={props.template}
                    placeholder="متن پیامک"
                />

                <Stack
                    direction="row"
                    justifyContent="space-between"
                    sx={{
                        py: 1,
                        position: "absolute",
                        bottom: 4,
                        right: 12,
                        left: 12,
                    }}
                    gap={1}
                >
                    <Chip
                        label={isPersian ? "فارسی" : "English"}
                        size="small"
                        color={isPersian ? "success" : "warning"}
                    />

                    <Chip size="small" label={`${charCount}  کاراکتر`} />
                    <Chip size="small" label={`${partCount}  پارت`} />

                    <Box sx={{ flexGrow: 1 }} />

                    <ButtonGroup
                        size="small"
                        sx={{ display: { xs: "none", sm: "flex" } }}
                        variant="outlined"
                    >
                        <Button onClick={openSelectTemplate}>
                            پیش نویس ها
                        </Button>

                        <Button onClick={addConstructorNamePlaceHolder}>
                            افزودن نام مخاطب
                        </Button>
                    </ButtonGroup>
                </Stack>
            </Box>

            <ButtonGroup
                size="small"
                fullWidth
                sx={{ display: { xs: "default", sm: "none" }, mt: 2 }}
                variant="outlined"
            >
                <Button onClick={openSelectTemplate}>پیش نویس ها</Button>

                <Button onClick={addConstructorNamePlaceHolder}>
                    افزودن نام مخاطب
                </Button>
            </ButtonGroup>

            {/*<Alert severity='warning' sx={{mt: 2}}>*/}
            {/*    به انتهای متن پیام شما عبارت "لغو۱۱" افزوده خواهد شد*/}
            {/*</Alert>*/}
        </Box>
    );
}
